export default __webpack_public_path__ + "static/media/gallery_01.b6b2c611.jpg";